<script setup lang="ts">
import DeleteIcon from '@/dashboard/vue/components/icons/DeleteIcon.vue';
import VisibilityChanger from '@/dashboard/vue/components/project/VisibilityChanger.vue';
import TeamChanger from '@/dashboard/vue/components/project/TeamChanger.vue';
import ContextMenuButton from '@/dashboard/vue/components/common/ContextMenu/ContextMenuButton.vue';
import SettingsIcon from '@/dashboard/vue/components/icons/SettingsIcon.vue';
import TitlePanel from '@/dashboard/vue/components/TitlePanel.vue';
import { useWorkspaceTitlePanel } from '@/dashboard/vue/components/workspace/WorkspaceTitlePanel/useWorkspaceTitlePanel';
import ArchiveIcon from '@/dashboard/vue/components/icons/ArchiveIcon.vue';
import LogoutIcon from '@/dashboard/vue/components/icons/LogoutIcon.vue';
import InfoIcon from '@/dashboard/vue/components/icons/InfoIcon.vue';
import Tooltip from '@/dashboard/vue/components/common/Tooltip.vue';

const { canShowMenu, canAddUsers, team, menuItems, workspace, addUser } = useWorkspaceTitlePanel();
</script>

<template>
  <div class="flex items-center px-s laptop:px-[12px]">
    <TitlePanel v-if="workspace" :show-pro-logo="workspace.subscription?.status === 'active'" :title="workspace.name" :show-menu="canShowMenu">
      <template #components>
        <div class="flex w-full flex-col gap-xs py-s laptop:w-auto laptop:flex-row laptop:items-center laptop:justify-start laptop:gap-s">
          <VisibilityChanger
            :is-workspace="true"
            :current="workspace ? workspace?.type : 'private'"
            :editable="false"
            :owner="!!workspace?.is_owner"
          />

          <TeamChanger
            v-if="!!workspace ? workspace?.type === 'team' : false"
            :owner="false"
            :team="team"
            :add-action="addUser"
            :editable="canAddUsers"
          />
        </div>
      </template>
      <template #menu-body>
        <template v-for="item in menuItems" :key="item.label">
          <ContextMenuButton v-if="item.canRender" :need-dark="true" :action="item.action" class="w-full">
            <div class="flex items-center gap-x-[10px] whitespace-nowrap">
              <LogoutIcon v-if="item.icon === 'LogoutIcon'" :class="['h-s w-s', item.iconClass]" />
              <ArchiveIcon v-else-if="item.icon === 'ArchiveIcon'" :class="['h-s w-s', item.iconClass]" />
              <SettingsIcon v-else-if="item.icon === 'SettingsIcon'" :class="['h-s w-s', item.iconClass]" />
              <DeleteIcon v-else-if="item.icon === 'DeleteIcon'" :class="['h-s w-s', item.iconClass]" />
              <span class="text-caption-s" :class="item.labelClass">{{ item.label }}</span>
              <Tooltip v-if="item.help">
                <template #title>
                  <InfoIcon class="stroke-gray-400 dark:stroke-gray-650" />
                </template>
                <template #body>
                  <span class="w-[264px]">{{ item.help }}</span>
                </template>
              </Tooltip>
            </div>
          </ContextMenuButton>
        </template>
      </template>
    </TitlePanel>
  </div>
</template>
